import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';

export type Step3Props = {
  emailSubject: string;
  setEmailSubject: (v: string) => void;
  emailTemplate: string;
  setEmailTemplate: (v: string) => void;
  emailBody: string;
  setEmailBody: (v: string) => void;
  emailTemplateOptions: { label: string; value: string }[];
  emailBodyLoading?: boolean;
  onSearchTemplates?: (query: string) => void;
  emailTemplatesLoading?: boolean;
};

const Step3: React.FC<Step3Props> = ({
  emailSubject,
  setEmailSubject,
  emailTemplate,
  setEmailTemplate,
  emailBody,
  setEmailBody,
  emailTemplateOptions,
  emailBodyLoading = false,
  onSearchTemplates,
  emailTemplatesLoading = false,
}) => (
  <div className="page">
    <div className="page__sectionHeader">
      <div>
        <h2 className="page__title">Email</h2>
        <p className="page__muted">Customize the email to be sent</p>
      </div>
    </div>
    <div className="page__twoCol" style={{ gridTemplateColumns: '1fr' }}>
      <div className="pageCard" style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div>
          <div className="page__muted" style={{ marginBottom: 4 }}>Select template</div>
          <Dropdown
            value={emailTemplate || null}
            options={emailTemplateOptions}
            onChange={e => setEmailTemplate(e.value ?? '')}
            placeholder="Select a template"
            style={{ width: '100%' }}
            appendTo={document.body}
            emptyMessage={emailTemplatesLoading ? 'Searching...' : 'No available options'}
            filter
            filterPlaceholder="Search templates..."
            onFilter={(e) => onSearchTemplates?.(e.filter)}
          />
        </div>
        <div>
          <div className="page__muted" style={{ marginBottom: 4 }}>Subject</div>
          <InputText maxLength={200}
            value={emailSubject}
            onChange={e => setEmailSubject(e.target.value)}
            placeholder="Subject"
            style={{ width: '100%' }}
          />
        </div>
        <div>
          <div className="page__muted" style={{ marginBottom: 4 }}>Body</div>
          <div style={{ position: 'relative' }}>
            <InputTextarea
              value={emailBodyLoading ? '' : emailBody}
              onChange={e => setEmailBody(e.target.value)}
              rows={7}
              placeholder={emailBodyLoading ? '' : 'Write your email body here...'}
              style={{ width: '100%', opacity: emailBodyLoading ? 0.4 : 1 }}
              disabled={emailBodyLoading}
            />
            {emailBodyLoading && (
              <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
                <i className="pi pi-spin pi-spinner" style={{ fontSize: 22, color: '#381574' }} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Step3;
